import { render, staticRenderFns } from "./EditPurchasesDeliveryPage.vue?vue&type=template&id=078f1a69"
import script from "./EditPurchasesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./EditPurchasesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports